import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: "sticky",
    style: _normalizeStyle({
      height: _ctx.height + 'px',
      zIndex: _ctx.zIndex
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.className),
    style: _normalizeStyle({
      top: _ctx.isSticky ? _ctx.top === -1 ? 'initial' : _ctx.top + 'px' : '',
      bottom: _ctx.isBottom ? 0 : 'initial',
      zIndex: _ctx.zIndex,
      position: _ctx.position,
      width: _ctx.width,
      height: _ctx.height + 'px'
    })
  }, [_renderSlot(_ctx.$slots, "default", {}, () => [_cache[0] || (_cache[0] = _createElementVNode("div", null, "sticky", -1 /* HOISTED */))])], 6 /* CLASS, STYLE */)], 4 /* STYLE */);
}